import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Showroom from "@/pages/Showroom";
import CatalogueRange from "@/pages/CatalogueRange";
import Embed from "@/pages/Embed";
import SocialPack from "@/pages/SocialPack";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App dark">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Showroom />} />
            <Route path="/range" element={<CatalogueRange />} />
            <Route path="/embed" element={<Embed />} />
            <Route path="/social" element={<SocialPack />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
